
import * as React from 'react';
import {
    Select,
    Button,
    Input,
    IconButton,
    InputAdornment,
    Typography,
    InputLabel,
    TextField,
    MenuItem,
  } from "@mui/material";

const SelectView = (props) => {
    return (
        <>
            <Select
                name={props.name}
                value={props.value}
                onChange={props.handleSelect}
                autoWidth
                required
                sx={{
                    width: '100%',
                    height: '56px',
                    position: 'relative',
                    marginRight: '12px'
                }}
                >
                    {props?.option?.map((item, index) => (
                        <MenuItem value={item} key={index}>
                            {item}
                        </MenuItem>
                    ))}
            </Select>
        </>
    )

}
export default SelectView;